import React, { Component } from 'react';
import Snps from "./Snps";
import Pubs from "./Pubs";
import Quotes from "./Quotes";

class Category extends Component {
  render(){
    const info = this.props.info;
    document.title = this.props.id + " - moreygenetics.com";
    /*var quotes_list = [];
    if (Object.keys(info).includes("quotes")) {
      
      for (let i=0;i<info["quotes"].length;i++) {
        //({ title, year, pubmed, pmcid, authors, text } = info["quotes"]);
        quotes_list.push(
          <Quote info={info["quotes"][i]}>
            {info["quotes"][i]["text"]}
          </Quote>
        );
      }
    }*/

    return(
      <div>
        {
          // https://css-tricks.com/emoji-as-a-favicon/
          Object.keys(info).includes("emoji")&&
          <link rel="icon" href={"data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><text y=%22.9em%22 font-size=%2290%22>"+info["emoji"]+"</text></svg>"}/>
        }
        {
          // Quote
          Object.keys(info).includes("quotes")&&
          <Quotes info={info["quotes"]} key="quotes"/>
        }
        {
          // Text
          Object.keys(info).includes("text")&&
          <div id="text" dangerouslySetInnerHTML={{__html:info["text"]}}></div>
        }
        {
          // Snps
          // The "key" property insures that the Snp component remounts when facebook info is available
          Object.keys(info).includes("snps")&&
          <Snps snps={info["snps"]} key={this.props.sub} credential={this.props.credential}/>
        }
        {
          // Publications
          (Object.keys(info).includes("pubs") || Object.keys(info).includes("details"))&&
          <Pubs ids={info["pubs"]} details={info["details"]}/>
        }
      </div>
    );
  }

}

export default Category;